import script from "./edit-contact-details.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit-contact-details.vue?vue&type=script&setup=true&lang=ts"

import "./edit-contact-details.vue?vue&type=style&index=0&id=4e02539b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e02539b"]])

export default __exports__